module.exports = __webpack_public_path__ + "media/images/grey_logos/gma-1fb477fd6348e8fb6b28c82d11d4cbc5.svg";